"use strict";

exports.__esModule = true;
exports.getAxisOptions = void 0;
var _constants = require("../../constants");
var _valueFormatters = require("../valueFormatters");
var _timeFormatters = require("../timeFormatters");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getAxisOptions = exports.getAxisOptions = function getAxisOptions(chartItems, timezone, yAxisFormatter, xAxisFormatter, useZeroAsBase, targetValue, predefinedMaxValue) {
  if (yAxisFormatter === void 0) {
    yAxisFormatter = _valueFormatters.defaultValueFormatter;
  }
  if (xAxisFormatter === void 0) {
    xAxisFormatter = _timeFormatters.defaultXAxisFormatter;
  }
  if (useZeroAsBase === void 0) {
    useZeroAsBase = true;
  }
  var items = chartItems == null ? void 0 : chartItems.props;
  var parsedTarget = parseFloat(targetValue);
  var xAxis = [];
  var yAxis = [];
  if ((items == null ? void 0 : items.length) > 0) {
    var _loop = function _loop() {
      var _step$value = _step.value,
        index = _step$value[0],
        chartItem = _step$value[1];
      if (chartItem.chartType === _constants.CHART_LINE || chartItem.chartType === _constants.CHART_BAR || chartItem.chartType === _constants.CHART_SCATTER) {
        var _chartItem$appearance, _chartItem$appearance2;
        xAxis.push({
          type: _constants.AXIS_TIME,
          boundaryGap: false,
          gridIndex: index,
          show: !(chartItem != null && (_chartItem$appearance = chartItem.appearance) != null && _chartItem$appearance.hideXAxis),
          axisLabel: {
            formatter: xAxisFormatter(timezone),
            hideOverlap: true
          }
        });
        var lineTrends = chartItem.lineTrends ? chartItem.lineTrends.map(function (trend) {
          return trend.value;
        }) : [];
        var singleYAxis = {
          type: _constants.AXIS_VALUE,
          gridIndex: index,
          max: function max(value) {
            return getMax(predefinedMaxValue, value, lineTrends, parsedTarget);
          },
          show: !(chartItem != null && (_chartItem$appearance2 = chartItem.appearance) != null && _chartItem$appearance2.hideYAxis),
          axisLabel: {
            formatter: yAxisFormatter
          }
        };
        if (!useZeroAsBase) {
          singleYAxis.min = function (value) {
            return prepareMinMax(value, lineTrends, parsedTarget).min;
          };
        }
        yAxis.push(singleYAxis);
      } else {
        xAxis.push({
          type: _constants.AXIS_CATEGORY,
          gridIndex: index,
          show: false
        });
        yAxis.push({
          type: _constants.AXIS_VALUE,
          gridIndex: index,
          show: false
        });
      }
    };
    for (var _iterator = _createForOfIteratorHelperLoose(items.entries()), _step; !(_step = _iterator()).done;) {
      _loop();
    }
  }
  if (xAxis.length === 0 || yAxis.length === 0) {
    return {
      xAxis: [],
      yAxis: []
    };
  }
  return {
    xAxis: xAxis,
    yAxis: yAxis
  };
};
var getMax = function getMax(maxValue, value, lineTrends, targetValue) {
  if (maxValue) {
    return maxValue;
  }
  return prepareMinMax(value, lineTrends, targetValue).max;
};
var prepareMinMax = function prepareMinMax(value, lineTrends, targetValue) {
  var lines = !isNaN(targetValue) ? [].concat(lineTrends, [targetValue]) : lineTrends;
  var max = Math.max.apply(Math, [value.max].concat(lines));
  var min = Math.min.apply(Math, [value.min].concat(lines));
  var padding = (max - min) * 0.1;
  return {
    min: Math.floor(min - padding),
    max: Math.ceil(max + padding)
  };
};